import React from "react";
import styles from "./ButtonsContainer.module.scss";

const ButtonsContainer = ({ children, className = "" }) => {
    return <div className={`${styles.actionsContainer} ${className}`}>{children}</div>;
};

export default ButtonsContainer;
